module.exports = __webpack_public_path__ + "img/hero-about.6cf08252.jpg";